/**
 * Retrieves a runtime environment variable value for PiiLink DigitalTwin Client.
 *
 * Evaluation order:
 * 1. window.env[key] (injected at container startup, ignoring unpopulated placeholders like "${REACT_APP_...}")
 * 2. process.env[key] (CRA build-time / development environment variable)
 * 3. fallback value
 */
export function getRuntimeEnv(key, fallback = '') {
  if (typeof window !== 'undefined' && window.env && window.env[key]) {
    const val = window.env[key];
    if (val && !val.startsWith('${')) {
      return val;
    }
  }

  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    const processVal = process.env[key];
    if (processVal !== undefined && processVal !== '') {
      return processVal;
    }
  }

  return fallback;
}
